import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { convertEpochToDateTime, GetAllOpenAuction, GetAuctionDetails, GetAuctionList } from '../../hooks/AuctionHook';
import { getDataFromURI } from '../../hooks/Tokenhook';
import { getUserByAddress } from '../../hooks/User';
import { listNFTs } from '../../hooks/NFTHook';
import { FaRegCirclePlay } from 'react-icons/fa6';

const HeroAuctions = () => {
  const [auctions, setAuctions] = useState('');
    const [isHovered, setIsHovered] = useState(false);

  const userIds = localStorage.getItem("userId");

  useEffect(() => {
    GetAuctions()
    // GetAllOpenAuction().then(async (data) => {
    //   if (data.status === 201) {
    //     const Arr = data.data;
    //     const GetAlmostEndedAucntion = getAuctionWithMinimumEndTime(Arr)
    //     if (GetAlmostEndedAucntion) {
    //       const res = await getDataFromURI(GetAlmostEndedAucntion.tokenURI);
    //       const endTime = new Date(GetAlmostEndedAucntion.endTime * 1000)
    //       const dataOfURI = res.data;
    //       const AuctionDetails = await GetAuctionDetails(GetAlmostEndedAucntion.auctionId);
    //       if (AuctionDetails.status === 200) {
    //         const Auction = AuctionDetails.data;
    //         console.log("Sutib", Auction);

    //         setAuctions({
    //           ...GetAlmostEndedAucntion,
    //           // endTime:endTime.toLocaleString(),
    //           title: dataOfURI.title,
    //           image: dataOfURI.image,
    //           type: dataOfURI.type,
    //           highestBid: Auction.highestBid,
    //           category: dataOfURI.category,
    //           desc: dataOfURI.desc,
    //         })
    //       }
    //       else {
    //         setAuctions({
    //           ...GetAlmostEndedAucntion,
    //           // endTime:endTime.toLocaleString(),
    //           title: dataOfURI.title,
    //           image: dataOfURI.image,
    //           type: dataOfURI.type,
    //           highestBid: 0,
    //           category: dataOfURI.category,
    //           desc: dataOfURI.desc,
    //         })
    //       }
    //     }
    //   }
    // })
  }, [])

  const GetAuctions = async () => {
    const params = { page: 1, limit: 1, active: true, sortBy: "createdAt" }
    const { success, data, total, totalPages, page } = await GetAuctionList(params)
    if (success)
      console.log("AuctionListActive", data, total, totalPages, page);
    // setAuctions(data)
    const collectionsWithMarketData = await Promise.all(
      data.map(async (collection) => {
        const marketData = await fetchMarketData(collection);
        const MarketNFTs = marketData.data;
        const AddIsLikeFlag = MarketNFTs.map(item => {
          const isLike = item.likes.some(like =>
            like.userId === userIds // Check if the user's ID exists in the likes array
          );

          return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
        });
        const getEndTime = convertEpochToDateTime(collection.endTime)
        console.log("AddIsLikeFlag", AddIsLikeFlag, getEndTime);
        return {
          ...collection,
          updateEndTime: getEndTime,
          ...AddIsLikeFlag[0]
        };
      })
    );
    setAuctions(collectionsWithMarketData[0])
  }

  const fetchMarketData = async (data) => {
    try {
      const params = {
        tokenId: data.tokenId,
        contractAddress: data.collectionAddress,
      };
      const response = await listNFTs(params);

      return response.success ? response : { success: false, data: [] };
    } catch (error) {
      console.error("Error fetching market data:", error);
      return { success: false, data: [] };
    }
  };

  const CountdownTimer = ({ targetEpoch }) => {
    const calculateTimeLeft = () => {
      const difference = targetEpoch * 1000 - Date.now();
      let timeLeft = {};

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearTimeout(timer);
    });

    return (
      <div>
        {timeLeft.days !== undefined ? (
          <p className="text-center text-white">{timeLeft.days}:{timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}</p>
        ) : (
          <p className='text-white'>Time's up!</p>
        )}
      </div>
    );
  };

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1)
  };
  return (
    <div className="hero_Live_Auctions">
      <div className="container">
        {/* <button
          onClick={handleBackClick}
          className="btn btn-white btn-sm my-40 ml-4"
        >
          Back
        </button> */}
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-12 col-sm-12 space-y-10 left_content">
            <img
              className="img-fluid"
              src="img/icons/bid-grad.png"
              alt="bid icon"
            />
            <h1 className="text-left">Live Auctions</h1>
            <p>
            Stay ahead! Get exclusive updates on live auctions, NFTs, dApps, and Web3 trends—subscribe now!
            </p>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="card__item one">
              <div className="card_body space-y-10">
                <div className="row align-items-center">
                  <div className="col-xl-7 col-md-7 col-sm-7 space-y-20 card_left">
                    <div className="space-y-20">
                      <h4>{auctions?.title}</h4>
                      <div className="details d-flex justify-content-between">
                        <div className="bid">
                          <div>
                            <p className="text_in_bl txt_xs">CURRENT BID</p>
                            <span className="txt_sm">{auctions?.highestBid} ETH</span>

                          </div>
                        </div>
                        <div className="auction_end">
                          <p className="text_in_bl txt_xs">AUCTION END</p>
                          <span className="counter txt_sm"> <CountdownTimer targetEpoch={auctions?.endTime} /></span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center space-x-20">
                      <div>
                        <Link to={`/auction/details/${auctions?.contractAddress}/${auctions?.auctionId}`} className="btn btn-white">
                          View Live Auction
                        </Link>
                      </div>
                      <div>
                        <Link to={`/auction/details/${auctions?.contractAddress}/${auctions?.auctionId}`}>
                          <button className="btn btn-grad" >Place Bid</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-md-5 col-sm-5">
                    <div className="card_right">
                      <Link to={`/auction/details/${auctions?.contractAddress}/${auctions.auctionId}`}>
                         {/* <img src={auctions && auctions.image} alt=".." /> */}
                        {auctions?.assetType?.split("/")[0] !== "image" ? (
                          <div
                            className="video-wrapper"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <video
                              style={{ borderRadius: "18px" }}
                              muted
                              loop
                              playsInline
                              className={`video ${isHovered ? "playing" : ""}`}
                              onMouseEnter={(e) => e.target.play()}
                              onMouseLeave={(e) => e.target.pause()}
                            >
                              <source src={auctions.imageUri} type={auctions.assetType} />
                              Your browser does not support the video tag.
                            </video>
                            {!isHovered && <div className="pause-overlay"><FaRegCirclePlay /></div>}
                          </div>
                        ) : (
                          <img
                            src={auctions.imageUri}
                            alt={`Preview ${auctions.assetType}`}
                            style={{ borderRadius: "18px" }}
                          />
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroAuctions;
